import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'auth-ui', {
    newPassword: 'New password',
    reenterPassword: 'Re-enter password',
    approveEmailChangeRespond: 'To approve the change, please respond to the email sent to',
    enterVerificationCodeSentTo: 'Enter the verification code sent to',
    enterCode: 'Enter code',
    resendCode: 'Resend code',
    cancelVerification: 'Cancel verification',
    emailNotVerified: 'Your email is not verified.',
    sendVerificationCode: 'Send verification code',
    emailAddressLabel: 'Email address',
    notVerified: 'Not Verified',
    verifyEmailAddressTitle: 'Verify Email Address',
    cancelUpdate: 'Cancel update',
    mobilePhoneNumberLabel: 'Mobile phone number',
    verifyPhoneNumberTitle: 'Verify Phone Number',
    emailAddressHeading: 'Email Address',
    emailAddressDescription:
      'Your email address is used to log in to your account and to receive notifications. Change how you receive notifications in the',
    mobilePhoneNumberHeading: 'Mobile Phone Number',
    mobilePhoneNumberDescription:
      'Your mobile phone number is used for Multi-Factor Authentication and to receive notifications. Change how you receive notifications in the',
    passwordDescription:
      'A password is set up to log in to your account. Change your password to keep your account secure.',
    notAuthorized: 'You are not authorized!',
    notAuthorizedDescription: 'You don′t have permission to access this page.',
    backToHome: 'Back to Home',
    loggedInAs: 'You are logged in as',
    logOut: 'Log out',
    pageNotFound: 'Page not found!',
    pageNotFoundDescription: 'The page you are looking for does not exist.',
    internalServerError: 'Internal server error!',
    internalServerErrorDescription: 'Oops, something went wrong!',
    emailPlaceholder: 'user@email.com',
    backToLogin: 'Back to login',
    resendVerificationCode: 'Resend verification code',
    newPasswordLabel: 'New Password',
    confirmPasswordLabel: 'Confirm Password',
    resetPasswordButton: 'Reset password',
    welcomeTo: 'Welcome to',
    continueAdventure: 'Please log in to continue your adventure.',
    newOnPlatform: 'New on our platform?',
    createAccount: 'Create an account',
    forgotPassword: 'Forgot password',
    resetYourPassword: 'Reset your password',
    enterNewPasswordBelow: 'Enter your new password below',
    signUp: 'Sign up',
    lifeTransformation: 'Your life transformation adventure starts here.',
    givenNameLabel: 'Given name',
    familyNameLabel: 'Family name (optional)',
    agreeToThe: 'I agree to the',
    privacyPolicy: 'Privacy Policy',
    and: '&',
    termsOfUse: 'Terms of Use',
    alreadyHaveAccount: 'Already have an account?',
    logInInstead: 'Log in instead',
    notApprovedYetMessage:
      'Thank you for your interest! You will receive an email when you are approved. Your patience is appreciated as we scale our capacity.',
    verifyingEmailMessage: 'We are verifying your email address. Please wait a moment.',
    clickButtonToReceiveCode: 'Click the button below to receive a verification code at',
    checkSpamFolder: "If you can't find the email, check your spam folder.",
    isNotYou: 'is not you?',
    signOut: 'Sign out',
    passwordChangedSuccessfully: 'Password changed successfully',
    privateActive: 'Private - Only you can see this.',
    privateActiveHint: 'Click to make it not-private.',
    privateInactive: 'Not private - Anyone you invite to see your habits can see this.',
    privateInactiveHint: 'Click to make it private.',
    updateTimezoneTitle: 'Update Timezone?',
    updateTimezoneConfirm: 'Update Timezone',
    keepCurrentTimezone: 'Keep Current',
    timezoneUpdated: 'Timezone updated to {{timezone}}',
    unableToLogInEmailInUse: 'Unable to log in. The user email may be already in use.',
    authenticationError: 'Authentication error: {{error}}',
  });
}
